/**
 * 当前用户全局数据
 */
import request from "@/api/store/management";

//数字格式化
function toThousands(num){
    var num = (num || 0).toString(),
        result = "";
    while (num.length > 3) {
        result = "," + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
    }
    if (num) {
        result = num + result;
    }
    return result;
}


const state = {
    //所有app数量
    allApps:0,
    //上架app数量
    apps:0,

    //应用下载量
    alldowncounts:0,
    //今日下载量
    downcounts:0,

    //总评论数
    allcomments:0,
    //今日评论
    comments:0,
}

const getters = {
    //所有app数量
    allApps(state){return toThousands(state.allApps)},
    //上架app数量
    apps(state){return toThousands(state.apps)},

    //应用下载量
    alldowncounts(state){return toThousands(state.alldowncounts)},
    //今日下载量
    downcounts(state){return toThousands(state.downcounts)},

    //总评论数
    allcomments(state){return toThousands(state.allcomments)},
    //今日评论
    comments(state){return toThousands(state.comments)},
}

const mutations = {
    getPageStatus(state) {
        request
            .apps()
            .then((res) => {
            if (res.datas && res.status === 200) {
                state.allApps = res.datas.total_apps;
                state.apps = res.datas.on_shelf_apps;
            }
            })
            .catch(() => {
            state.allApps = 0;
            state.apps = 0;
            });
        request
            .downcounts()
            .then((res) => {
            if (res.datas && res.status === 200) {
                state.alldowncounts = res.datas.total_downcounts;
                state.downcounts = res.datas.last_downcounts;
            }
            })
            .catch(() => {
            state.alldowncounts = 0;
            state.downcounts = 0;
            });

    },
    getCommentsCount(){
        request
            .comments()
            .then((res) => {
            if (res.datas && res.status === 200) {
                state.allcomments = res.datas.total_comments;
                state.comments = res.datas.last_comments;
            }
            })
            .catch(() => {
            state.alldowncounts = 0;
            state.downcounts = 0;
            });
    }
}

const actions = {
    updatePageStatus({commit}) {
        commit('getPageStatus');
        commit('getCommentsCount');
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
